// eslint-disable-next-line import/prefer-default-export
export class Env {
  static isAppInDevelopEnvironment() {
    return process.env.VUE_APP_ENV === 'develop';
  }

  static isAppProductionEnvironment() {
    return process.env.VUE_APP_ENV === 'production';
  }
}
